import { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UserContext from '../../../store/user-context';
import { useSpeechSDK } from '../../Helpers/Conversation/SpeechDetection';

const PreteachButton = (props) => {
  const { user } = useContext(UserContext);
  const [isButtonActive, setIsButtonActive] = useState(false);
  const buttonId = `button-${props.id}`;
  const dispatch = useDispatch();
  const playButtonAudio = useSelector((state) => state.playButtonAudio);
  const activeSection = useSelector((state) => state.activeSection);

  //Flag consts
  let localLang = user.user.language || 'english'; //default to british if no value exists
  localLang = localLang === 'british' ? 'english' : localLang;
  const localFlag = `/flags/${localLang}.png`;
  const learning = user.user.learning;
  const learningFlag = `/flags/${learning}.png`;

  function buttonStateHandler() {
    if (playButtonAudio === true) return;

    if (!isButtonActive) {
      playAudio();
    }
    setIsButtonActive(!isButtonActive);
    props.checkSlideStatus(buttonId, !isButtonActive);
  }

  const checkIfComplete = () => {
    const buttons = props.completedButtons;

    if (buttons.includes(buttonId)) {
      setIsButtonActive(true);
    }
  };

  const playAudio = () => {
    if (useSpeechSDK() && activeSection === 0) {
      document.getElementById('button_audio_player').load();
      document.getElementById('button_audio_player').play();
    }

    dispatch({
      type: 'playButtonAudio',
      payload: { buttonOrder: props.data.splitNumber },
    });
  };

  useEffect(() => {
    checkIfComplete();
  }, [checkIfComplete]);

  return (
    <div
      key={props.buttonKey}
      className={`conversation-button 
      ${isButtonActive ? 'conversation-button--active' : ''}
      ${
        playButtonAudio && !props.completedButtons.includes(buttonId)
          ? 'conversation-button--disabled'
          : ''
      }
      `}
      onClick={buttonStateHandler}
    >
      <img src={localFlag} alt={localFlag} className="flag flag--local" />
      {isButtonActive && <p>{props.data.learningLang}</p>}
      {!isButtonActive && <p>{props.data.nativeLang}</p>}
      <img
        src={learningFlag}
        alt={learningFlag}
        className="flag flag--learning"
      />
    </div>
  );
};

export default PreteachButton;
